import { Injectable, inject } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  RedirectCommand,
} from '@angular/router';
import { CommonService } from '../../services/common.service';
import { OrderCompleteService } from '../../services/orderComplete.service';
import { SpinnerOverlayService } from '../../shared/spinner/spinner-overlay.service';
import { DOCUMENT } from '@angular/common';
import { CatalogUpSellsType } from 'src/app/models/enum';

@Injectable({
  providedIn: 'root',
})
export class OrderCompleteResolver implements Resolve<any | RedirectCommand> {
  private orderCompleteService = inject(OrderCompleteService);
  private commonService = inject(CommonService);
  private spinnerOverlayService = inject(SpinnerOverlayService);
  private _document = inject<Document>(DOCUMENT);

  iFrameUrl: Window;
  constructor() {
    this.iFrameUrl = this._document.defaultView;
  }

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    const orderId = (this.commonService.orderIdentifier =
      route.queryParams.orderid);
    const isOrderProcessing = route.queryParams.isOrderProcessing;
    const orderNumber = route.queryParams.orderNumber;
    this.commonService.isMembership = route.queryParams.isMembership
      ? JSON.parse(route.queryParams.isMembership)
      : false;
    let isOrderFromUrl =
      orderId && this.commonService.applicationId ? false : true;
    var data = {
      orderId: orderId,
      isOrderProcessing: isOrderProcessing,
      orderNumber: orderNumber,
    };
    let orderCompleteObj = {
      orderId: Number,
      classPassId: Number,
    };
    orderCompleteObj.orderId = orderId;
    orderCompleteObj.classPassId =
      (this.commonService.isClassPass ||
        route.queryParams.hasOwnProperty('classPassId')) &&
      route.queryParams.classPassId
        ? route.queryParams.classPassId
        : null;
    this.commonService.isClassPass = route.queryParams.classPassId
      ? true
      : false;
    this.spinnerOverlayService.startSpinning();
    if (this.iFrameUrl.top.location != this.iFrameUrl.location) {
      this.iFrameUrl.top.location = this.iFrameUrl.location.origin + state.url;
    }

    try {
      const orderComplete = await this.orderCompleteService
        .viewTicketDetails(orderCompleteObj)
        .toPromise();

      if (
        orderComplete['isSuccessful'] &&
        orderComplete['data'] &&
        orderComplete['data']['applicationId'] &&
        isOrderFromUrl
      ) {
        this.commonService.applicationId =
          orderComplete['data']['applicationId'];
        const showId = orderComplete['data']['showId'];
        if (showId) {
          this.commonService.setShowId(String(showId));
        }
        try {
          const result = await this.getDomainInformation();

          data['domainInformation'] = result;
        } catch (error) {
          console.error('getDomainInformation error:', error);
          data['domainInformation'] = null;
        }
      }
      this.spinnerOverlayService.stopSpinning();
      data['orderComplete'] = orderComplete;

      if (
        route.queryParams['purchased'] &&
        typeof route.queryParams['purchased'] === 'string'
      ) {
        data['isCatalogUpSells'] = route.queryParams['purchased'].includes(
          'order'
        )
          ? CatalogUpSellsType.ByOrder
          : CatalogUpSellsType.ByApplication;
      }

      return data;
    } catch (error) {
      console.error('Error during resolver:', error);
      this.spinnerOverlayService.stopSpinning();
      return {};
    }
  }

  getDomainInformation() {
    return new Promise(resolve => {
      this.commonService.getDomainInformation().subscribe(result => {
        if (result.isSuccessful && result.data) {
          resolve(result);
        }
      });
    });
  }
}
